module.exports = __webpack_public_path__ + "static/img/bg-tr.b22a7fd3.png";